import { Box } from "@mui/material";

interface Props
{
    imageSource: string
}

export default function Footer({ imageSource }: Props)
{
    return (
        <Box className="border">
            <Box className="borderLine"
                style={{
                    backgroundImage: `url(${imageSource}/intertitle/line.png)`
                }}>&nbsp;</Box>
            <Box className="borderLogo" style={{
                backgroundImage: `url(${imageSource}/intertitle/logo.png)`
            }}>&nbsp;</Box>
        </Box>

    );
}